const PARAMS = {
  id: 'id',
  categoryId: 'categoryId',
  pesticideId: 'pesticideId',
}

const ROUTE = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/sign-up',
  PESTICIDES: '/pesticides',
  PESTICIDESBYCATEGORY: '/pesticides-by-category',
  PESTICIDESBY: '/pesticides-by',
  PESTICIDESBYID: `/pesticides-by/:${ PARAMS.categoryId }`,
  PESTICIDEPREVIEW: '/pesticide-preview',
  PESTICIDEPREVIEWBYID: `/pesticide-preview/:${ PARAMS.pesticideId }`,
  SEEDS: '/seed',
  CART: '/cart',
  FERTILIZER: '/fertilizer',
  SEED: '/seed',
  ANIMAL: '/animal',
  DAIRY: '/dairy',
  FACILITIES: '/facilities',
  SEMINAR: '/seminar',
  KCC: '/kcc',
  ADVISOR: '/advisor',
  APPLY: '/apply',
  CONTACTUS: '/contact-us',
  ORDER: '/order',
  ACCOUNT: '/account',
  LOGOUT: '/logout',
}

export { PARAMS, ROUTE }
